import { IApplicationState } from '../../types/redux';

export const selectRegions = (state: IApplicationState) => state.regions;
